// removed by extract-text-webpack-plugin
module.exports = {"openhours-wrapper":"openhours-wrapper","openhours-day":"openhours-day","weekday":"weekday","time-range":"time-range","closed":"closed"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Form/Fields/OpenHours/OpenHours.scss
// module id = PjrO
// module chunks = 0